import { useCallback, useState } from "react";
import { useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';

export const FilterSporttak = (props) => {

    //State
    const [options, setOptions] = useState(null);

    //Callbacks
    const toggleCategory = useCallback((option) => {

        if (props.filter.values.includes(option)) {
            props.filter.values = props.filter.values.filter(v => v !== option);
        }
        else {
            props.filter.values.push(option);
        }

        const newState = { ...props.ficheData };

        props.setFicheData(prev => {
            return {
                ...prev,
                filter: newState.filter
            }
        });


    }, [JSON.stringify(props.filter.options), JSON.stringify(props.filter.values)]);

    useEffect(() => {
        const newOptions = [];
        if (props.filter.options) {
            for (let i = 0; i < props.filter.options.length; i++) {
                const option = props.filter.options[i];
                const id = `id_${uuidv4().replaceAll("-", "")}`;
                newOptions.push(
                    <li key={props.filter.contentUId + "_" + i}>
                        <button id={`${id}_btTrainerCategory_${i}`} className={`sporttak  ${props.filter.values.includes(option) ? "active" : ""}`} onClick={(evt) => {
                            document.querySelector(`#${id}_btTrainerCategory_${i}`).classList.toggle("active");
                            toggleCategory(option);
                        }}>
                            <i className={`sporttak-${option}`}></i>
                            <p>{option}</p>
                        </button>
                    </li>
                );
            }
            setOptions(newOptions);
        }
    }, [JSON.stringify(props.filter.options), JSON.stringify(props.filter.values)]);

    return <div className={`col-sm-${props.filter.gridWidth != 0 ? props.filter.gridWidth : 12}`}>
        <ul class="u-clear">
            {options}
        </ul>
    </div>
}